import React from 'react';
import RecommendedCities from '../components/recommended-cities/RecommendedCities';
import { useNavigate } from 'react-router-dom';
import CurrentEvents from '../components/CurrentEvents';
import HighlightsSection from '../components/home/HighlightsSection';
import SeoDescriptionSection from '../components/home/SeoDescriptionSection';

export default function LandingPage() {
  const navigate = useNavigate();
  const handleClick = (e) => {
    e.preventDefault();
    navigate('/start-plan');
  };
  return (
    <div>
      {/* Hero */}
      <section className="relative">
        <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=60')"
        }} />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center min-h-[calc(100vh-5rem)] text-white text-center py-20">
            <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight">Türkiye’de bu hafta nerede ne var?</h2>
            <p className="mt-6 text-lg md:text-xl max-w-2xl mx-auto text-foreground-dark/90">
              81 ilde konser, festival, doğa kaçamağı ve kapalı mekânları tek ekranda gör; istersen yapay zekâ ile sana özel gezi planı çıkar.
            </p>
            <div className="mt-10">
              <button onClick={handleClick} className="inline-block bg-primary text-white font-bold text-lg px-12 py-4 rounded-full shadow-lg hover:opacity-90 transition-all transform hover:scale-105">
                Planımı Oluştur
              </button>
            </div>
          </div>
        </div>
      </section>

      <HighlightsSection />
      <RecommendedCities />
      <CurrentEvents />
      <SeoDescriptionSection />
    </div>
  );
}
